var React = require('react');

function Knowledge (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17.0509 23.5508H8.58984C9.03055 25.4897 10.7932 26.9881 12.8202 26.9881C14.9355 26.9881 16.6983 25.4899 17.0506 23.5508H17.0509Z","fill":"#262626","key":0}),React.createElement("path",{"d":"M13.7009 17.9986V21.7885H17.1383V19.0563C20.3993 17.2055 22.3382 14.2969 22.3382 10.507C22.3382 5.21882 18.1078 0.988281 12.8195 0.988281C7.53132 0.988281 3.30078 5.21868 3.30078 10.507C3.30078 14.2969 5.32784 17.2052 8.50074 19.0563V21.7885H11.9381V17.9986L9.38214 15.3546C8.58887 14.5613 9.82284 13.3275 10.6161 14.1206L12.8195 16.3239L15.0228 14.1206C15.9042 13.3273 17.138 14.5613 16.2568 15.3546L13.7008 17.9986H13.7009Z","fill":"#262626","key":1})]);
}

Knowledge.defaultProps = {"width":"26","height":"27","viewBox":"0 0 26 27","fill":"none"};

module.exports = Knowledge;

Knowledge.default = Knowledge;
